module.exports = __webpack_public_path__ + "img/login_avatar.c8765d13.jpg";